import { GisSearchRequest } from './gis.search.request';

export class GisDeliveryNoteSearchRequest extends GisSearchRequest {
  DeliveryNoteNumber: number;
  InvoiceNumber: number;
  Reference: string;
}
